import SingleStepGenericView from "@/views/SingleStepGenericView.vue"
import DataIteratorValidator from "@/mixins/DataIteratorValidator"
export default {
  mixins: [DataIteratorValidator],
  data() {
    return {
      formulaireNonValide: false
    }
  },

  components: {
    SingleStepGenericView
  },

  created() {
    this.createdMethod()
  },

  methods: {
    async createdMethod() {
      this.loadParams(this.paramsName)
      this.createdCustom()
    },
    validate() {
      let mainFormRef = this.$refs.mainForm
      let dataIteratorRef = this.$refs.dataIterator
      if (mainFormRef) {
        const mainFormValid = mainFormRef.validate()
        if (dataIteratorRef) {
          const dataIteratoValid = this.validateDataIterator(dataIteratorRef)
          return mainFormValid && dataIteratoValid
        }
        return mainFormValid
      }
      return true
    },
    async submit() {
      this.formulaireNonValide = false
      if (this.validate()) {
        this.loading = true
        const res = await this.submitCustom()
        if (res) {
          if (res.data.traite) {
            this.$router.push({ name: "FormulaireTraite", params: { idFacture: res.data.facture, message: res.data.message, hideAppbar: true } })
          } else {
            this.$router.push({ name: "FormulaireSoumis", params: { idFacture: res.data.facture, message: res.data.message, hideAppbar: true } })
          }
        }
        this.loading = false

      } else {
        this.formulaireNonValide = true
      }
    },
  },
}
